<ng-container [formGroup]="form">
  <ng-container [formGroupName]="controlName">
    <ng-container *ngIf="!mode || mode === 'select'; else editModeTemplate">
      <app-autocomplete-with-controls (onControlTriggered)="changeMode($event)"
                                      (onDropdownSearch)="handleAddressSearch($event)"
                                      [dropdownSearchEnabled]="dropdownSearchEnabled"
                                      [class.mr-top-0]="!!internationalInv"
                                      [intertationalInv]="internationalInv"
                                      [formControl]="data"
                                      [dropdownSearching]="false"
                                      [dropdownSearchDebounceTime]="0"
                                      [options]="filteredOptions$ | async"
                                      [keyInputPrevent]="!!internationalInv"
                                      [transformFn]="transformFn"
                                      [config]="config"
                                      [controlsConfig]="controlsConfig"
                                      searchPlaceholder="Пошук"
                                      data-test-id="SenderAddressSelect"
                                      class="form-row" >
        <ng-template appAutocompleteOption let-option>
          {{ (option && option.CityDescription && option.AddressDescription ? createWarehouseDescription(option) : createDoorsDescription(option)) || '' }}
        </ng-template>
        <app-autocomplete-error *ngIf="!!errorMessages[CONTROL_NAMES.DATA]">
          {{ errorMessages[CONTROL_NAMES.DATA] }}
        </app-autocomplete-error>
      </app-autocomplete-with-controls>
    </ng-container>
    <ng-template #editModeTemplate>
      <np-inv-edit-container data-test-id="SenderAddressCreate"
                             [controlName]="controlName"
                             [formTypeName]="controlTypeName"
                             [isCancelable]="!!options.length"
                             (onCancel)="cancel()"
                             (onClear)="clear()">
        <np-inv-type-radio-group data-test-id="SenderAddressType"
                                 [formControlName]="CONTROL_NAMES.TYPE"
                                 [types]="types"
                                 [modifyClass]="'radio-row_mr-top'">
        </np-inv-type-radio-group>

        <ng-container [ngSwitch]="activeType">
          <div class="wrapp-form">
            <np-inv-address-warehouse *ngSwitchCase="AddressTypes.WAREHOUSE"
                                      [form]="form.get(controlName)"
                                      [templateValidation]="templateValidation"
                                      [controlName]="CONTROL_NAMES.DATA"
                                      [controlTypeName]="CONTROL_NAMES.TYPE"
                                      [invoiceForm]="invoiceForm"
                                      (onCitySelected)="setLatestCity($event)"
                                      [isTmz]="isTmz">
            </np-inv-address-warehouse>

            <np-inv-address-doors *ngSwitchCase="AddressTypes.DOORS"
                                  [form]="form.get(controlName)"
                                  [templateValidation]="templateValidation"
                                  [controlName]="CONTROL_NAMES.DATA"
                                  [latestCity]="latestCity"
                                  (onCitySelected)="setLatestCity($event)"
                                  [controlTypeName]="CONTROL_NAMES.TYPE">
            </np-inv-address-doors>

            <ng-container *ngIf="noteDisabled">
              <app-address-sender-note *ngSwitchCase="AddressTypes.DOORS"
                                      [form]="form.get(controlName)"
                                      [controlName]="'Note'">
              </app-address-sender-note>
            </ng-container>

            <np-inv-address-postbox *ngSwitchCase="AddressTypes.POSTBOX"
                                    [templateValidation]="templateValidation"
                                    [form]="form.get(controlName)"
                                    [invoiceForm]="invoiceForm"
                                    [controlName]="CONTROL_NAMES.DATA"
                                    [latestCity]="latestCity"
                                    (onCitySelected)="setLatestCity($event)"
                                    [controlTypeName]="CONTROL_NAMES.TYPE">
            </np-inv-address-postbox>
          </div>
        </ng-container>
      </np-inv-edit-container>
    </ng-template>
  </ng-container>
</ng-container>
